import React from 'react';
import css from './css.less';
import Input from '@/src/components/Antd/Input/Input';

const TableInput = (props) => {
  const [_focus, _setFocus] = React.useState(false);
  const { value, error, ...rest } = props;
  const onFocus = (e) => {
    e.stopPropagation();
    _setFocus(true);
  };
  const onBlur = () => {
    _setFocus(false);
  };

  React.useEffect(() => {
    document.addEventListener('click', onBlur);
    return () => {
      document.removeEventListener('click', onBlur);
    };
  }, []);
  React.useEffect(() => {
    if (error) {
      _setFocus(true);
    }
  }, [error]);

  const _editting = _focus || error;
  return (
    <div className={css.container} onClick={onFocus}>
      {_editting ? (
        <Input
          error={error}
          value={value}
          {...rest}
          onBlur={onBlur}
          autoFocus
        />
      ) : (
        value
      )}
    </div>
  );
};
export default TableInput;
